<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    confirm-text="保存"
    :title="title"
    width="35%"
    :confirm-disable="false"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="100px"
      >
        <el-form-item
          label="退款原因"
          prop="refundReason"
        >
          <el-input
            v-model="createForm.refundReason"
            type="textarea"
            placeholder="请输入退款原因"
          />
        </el-form-item>
      </el-form>
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import axClient from '@/services';

export default {
  name: 'Orderdialog',
  components: { customeDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    refundId: {
      type: [Number, null],
      default: null,
    },
  },
  data() {
    return {
      title: '退款原因',
      createForm: {
        id: null,
        refundReason: null,
      },
      creatRules: {
        refundReason: [
          { required: true, message: '请输入退款原因', trigger: 'change' },
        ],
      },
    };
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.createForm.clearValidate();
          this.$refs.createForm.resetFields();
        });
      }
    },
  },
  methods: {
    close() {
      this.$emit('update:dialogVisible', false);
      this.$emit('close');
    },
    confirm() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          this.createForm.id = this.refundId;
          const data = await axClient.order.refundByBackendUser(this.createForm);
          if (!data) return;
          this.$message.success('退款成功');
          this.$emit('update:dialogVisible', false);
          this.$emit('confirm');
        }
      });
    },
  },
};
</script>
